module.exports = __webpack_public_path__ + "static/media/mighty-kong.7712c521.gif";